import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Role } from '../types/interfaces/role';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { TicketStatus } from '../types/interfaces/ticket-status';
import {
  ChatbotIntegration,
  ChatbotIntentTemplateAttributes,
  NlpEntities,
} from '../types/interfaces/chatbot';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  constructor(private http: HttpClient) {}

  getRoles(): Observable<Role[]> {
    return this.http.get<Role[]>(`${environment.apiHost}/common/roles`, {
      withCredentials: true,
    });
  }

  getTicketStatuses(): Observable<TicketStatus[]> {
    return this.http.get<Role[]>(
      `${environment.apiHost}/common/ticket-statuses`,
      {
        withCredentials: true,
      }
    );
  }

  getChatbotStepTypes(): Observable<string[]> {
    return this.http.get<string[]>(
      `${environment.apiHost}/common/chatbot/step-types`,
      {
        withCredentials: true,
      }
    );
  }

  getChatbotIntegrations(): Observable<ChatbotIntegration[]> {
    return this.http.get<ChatbotIntegration[]>(
      `${environment.apiHost}/common/chatbot/integrations`,
      {
        withCredentials: true,
      }
    );
  }

  getNlpProviders() {
    return this.http.get<string[]>(
      `${environment.apiHost}/common/chatbot/nlp-providers`,
      {
        withCredentials: true,
      }
    );
  }

  getNlpEntities() {
    return this.http.get<NlpEntities[]>(
      `${environment.apiHost}/common/chatbot/nlp-entities`,
      {
        withCredentials: true,
      }
    );
  }

  getIntentTemplates() {
    return this.http.get<ChatbotIntentTemplateAttributes[]>(
      `${environment.apiHost}/intent-templates`,
      {
        withCredentials: true,
      }
    );
  }

  getIntentTemplate(id: number) {
    return this.http.get<ChatbotIntentTemplateAttributes>(
      `${environment.apiHost}/intent-templates/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  getIntentTemplatesBulk(ids: number[]) {
    return this.http.post<ChatbotIntentTemplateAttributes[]>(
      `${environment.apiHost}/intent-templates/bulk`,
      ids,
      {
        withCredentials: true,
      }
    );
  }
}
